import React from 'react';
import { useRequest } from 'ahooks';
import { Spin } from '@bedrock/components';
import { SupplierRequestInvoker, supplierDefs } from '@purchase/supplier';
import { XpcOverallCard } from './XpcOverallCard';
import { XpcOpusTable } from './XpcOpusTable';

export interface XpcSectionProps {
  vendorId: string;
  className?: string;
}

export function XpcSection({ vendorId, className }: XpcSectionProps) {
  const { data: dashboardData, loading } = useRequest(
    () => SupplierRequestInvoker.getInstance().vendorQueryXpcDashboard({ vendorId }),
    { refreshDeps: [vendorId] },
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center py-[32px]">
        <Spin />
      </div>
    );
  }

  const dashboard = dashboardData?.data as supplierDefs.VendorXpcDashboardDto | undefined;

  return (
    <div className={className}>
      <XpcOverallCard data={dashboard} />
      <XpcOpusTable vendorId={vendorId} />
    </div>
  );
}